module.exports = __webpack_public_path__ + "img/ring_r_i_0_0@3x.12453d75.png";